import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IDialogResult } from 'src/app/models/base.model';
import { AbstractMainAuthorForm } from 'src/app/models/Iabstracttableitem';
import { hasErr, markFormGroupTouched } from '../../validators/form.helper';

@Component({
  selector: 'app-person-abstract-edit-dialog',
  templateUrl: './person-abstract-edit-dialog.component.html',
  styleUrls: ['./person-abstract-edit-dialog.component.css']
})
export class PersonAbstractEditDialogComponent implements OnInit {

  isReady = false;

  form: UntypedFormGroup;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {
    const data = this.config.data as PersonAbstractEditDialogModel;

    this.form = new UntypedFormGroup({
      lastName: new UntypedFormControl(data.form?.lastName, Validators.required),
      firstName: new UntypedFormControl(data.form?.firstName, Validators.required),
      middleName: new UntypedFormControl(data.form?.middleName),
      workplace: new UntypedFormControl(data.form?.workplace, Validators.required),
      contactEmail: new UntypedFormControl(data.form?.contactEmail, [Validators.required, Validators.email]),
    });
    this.isReady = true;
   }

  ngOnInit(): void {
  }


  hasErr(control: AbstractControl, err: string): boolean {   return hasErr(control, err);  }

  submit(frm: UntypedFormGroup) {
    this.form.markAsPristine();
    markFormGroupTouched(this.form);
    if (!frm.valid) return;

    const data = frm.value as AbstractMainAuthorForm;
    this.ref.close({ submitted: true, data: data } as IDialogResult);
  }

  cancel() {
    this.ref.close({ submitted: false, data: null } as IDialogResult);
  }


}


export class PersonAbstractEditDialogModel {
  constructor(    public form: AbstractMainAuthorForm ) {}
}

export class PersonAbstractEditDialogResult implements IDialogResult {
  constructor(public submitted: boolean, public data: AbstractMainAuthorForm) { }
}
